import React, { useEffect, useState } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { db, storage } from "../../firebase";
import "./admin.css";

export const AdminIstoricPage = () => {
  const [headerImage, setHeaderImage] = useState("");
  const [headerFile, setHeaderFile] = useState<File | null>(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const ref = doc(db, "site_content", "history_page");
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        setHeaderImage(data.header_image || "");
        setTitle(data.title || "");
        setDescription(data.description || "");
      }
    };
    fetchData();
  }, []);

  const uploadHeaderImage = async () => {
    if (!headerFile) return;
    const storageRef = ref(storage, `history/banner_${Date.now()}`);
    const uploadTask = uploadBytesResumable(storageRef, headerFile);
    uploadTask.on("state_changed", undefined, console.error, async () => {
      const url = await getDownloadURL(uploadTask.snapshot.ref);
      setHeaderImage(url);
    });
  };

  const saveAll = async () => {
    await setDoc(doc(db, "site_content", "history_page"), {
      header_image: headerImage,
      title,
      description,
    });
    alert("Pagina Istoric a fost salvată cu succes!");
  };

  return (
    <div className="admin-container">
      <h1>Administrare Pagina Istoric</h1>

      <label>Imagine banner:</label>
      <input
        type="file"
        accept="image/*"
        onChange={(e) => setHeaderFile(e.target.files?.[0] || null)}
      />
      <button onClick={uploadHeaderImage}>Încarcă imagine</button>
      {headerImage && <img src={headerImage} alt="Preview" className="preview-img" />}

      <label>Titlu:</label>
      <input
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="Titlul paginii"
      />

      <label>Descriere:</label>
      <textarea
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="Descrierea paginii"
      />

      <button className="save-btn" onClick={saveAll}>Salvează</button>
    </div>
  );
};
